const theme = {
  name: "My UAE Startup",
  fullName: "Ramkumar",
  url: "",
  author: {
    name: "My UAE",
    profile_url: "",
  },
  contacts: {
    company:"My Startup L.L.C-FZ",

    address: "Business Center 1, M Floor, The Meydan Hotel, Nad Al Sheba, Dubai, U.A.E.",
    email: "info@myuaestartup.com",
    phone: "+971 - 586098408",
  },
};

export default theme;
